import { useSelector } from "react-redux";
import { useMatch } from "react-router-dom-v5-compat";

import {
  hasUserProvider,
  microsoftProvider
} from "services/firebase/auth/ssoProvider";

import { useSelectedSchool } from "seneca-common/features/schools/school-selection/hooks";
import {
  getPromptToConnectProviderSSO,
  isSignedIn
} from "seneca-common/features/user/state";

import { ROUTES } from "routing/routes";

export default function useShowConnectMicrosoftAccountModal() {
  const signedIn = useSelector(isSignedIn);
  const isOnDashboard = !!useMatch(ROUTES.DASHBOARD.path);
  const isOnTeacherHomepage = !!useMatch(ROUTES.TEACHER.HOME.path);
  const isMatchingLocation = isOnDashboard || isOnTeacherHomepage;

  const promptToConnectProvider = useSelector(getPromptToConnectProviderSSO);

  const { data: school } = useSelectedSchool({ enabled: signedIn });
  const suggestedProvider = school?.schoolEntity?.suggestedProvider;
  const userHasMicrosoftProvider = hasUserProvider(
    microsoftProvider.providerId
  );
  const shouldConnectToMicrosoftProvider =
    suggestedProvider === "microsoft" && !userHasMicrosoftProvider;

  const showModal =
    isMatchingLocation &&
    shouldConnectToMicrosoftProvider &&
    promptToConnectProvider;

  return showModal;
}
